<template>
  <ul :class="['agent-permissions-list', `agent-permissions-list--${size}`]">
    <li
      v-for="item in items"
      :key="keyFn(item)"
      class="agent-permissions-list__item"
      :class="{
        'agent-permissions-list__item--active': activeFn(item) === active,
      }"
      @click="$emit('click', item)"
    >
      <slot :item="item">
        {{ item.title }}
      </slot>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'AgentPermissionsList',
  props: {
    items: {
      type: Array,
      required: true,
    },
    keyFn: {
      type: Function,
      required: true,
    },
    activeFn: {
      type: Function,
      required: true,
    },
    active: {
      type: [String, Number],
      default: '',
    },
    size: {
      type: String,
      default: 'medium',
    },
  },
};
</script>

<style lang="scss">
.agent-permissions-list {
  margin: 0;
  padding-right: $global-padding * 1.875;
  @include rtl() {
    padding-right: 0;
    padding-left: $global-padding * 1.875;
  }

  &--big &__item {
    padding-top: rem-calc(8px);
    padding-bottom: rem-calc(8px);
  }

  &--medium &__item {
    padding-top: rem-calc(5px);
    padding-bottom: rem-calc(5px);
  }

  &__item {
    font-size: rem-calc(13px);
    color: $lb-darker-gray;

    padding: 0 $global-padding * 0.625;

    display: flex;
    align-items: center;

    border-radius: 5px;

    user-select: none;

    transition-duration: 0.2s;

    border: 1px solid transparent;

    cursor: pointer;

    &:not(:first-child) {
      margin-top: $global-margin * 0.75;
    }

    &--active,
    &:hover {
      background-color: #e4e6e9;
      border: 1px solid #d9dee5;
    }
  }
}
</style>
